import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-loading",
	templateUrl: "laoding.component.html",
})
export class LoadingComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
